<form [formGroup]="loginForm" (submit)="formSubmit($event)">
    <h3 *ngIf="isTitleForm" [textContent]="titleForm"></h3>
    <fieldset>
        <label [textContent]="emailLabel"></label>
        <input formControlName="email" type="text" [placeholder]="emailPlaceHolder"/>
        <div *ngIf="loginForm.controls['email'].touched && !loginForm.controls['email'].valid"> 
            <div class="form-err" *ngIf="loginForm.controls['email'].hasError('required')"> Email is required </div>  
            <div class="form-err" *ngIf="loginForm.controls['email'].hasError('pattern')"> Invalid Email </div>       
        </div>
    </fieldset>
    <fieldset>
        <label [textContent]="usernameLabel"></label>
        <input formControlName="username" type="text" [placeholder]="usernamePlaceHolder"/>
    </fieldset>
    <fieldset>
        <label [textContent]="passwordLabel"></label>
        <input formControlName="password" type="password" [placeholder]="passwordPlaceHolder"/>
        <div *ngIf="loginForm.controls['password'].touched && !loginForm.controls['password'].valid"> 
            <div class="form-err" *ngIf="loginForm.controls['password'].hasError('minlength') ">Password is required minimum 6 characters</div>
        </div>
    </fieldset>
    <div class="box-login-btn">
        <p class="error-msg">{{errorServer}}</p>
        <button type="submit" class="btn" [textContent]="nameLoginBtn"></button>
    </div>
</form>